import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import moment from 'moment';
import axios from '../../../services/axios-service';
import './InterviewPreview.css';

import {Durations, TimePeriod} from '../../../shared/constants';

import Icon from '../../../components/UI/Icon/Icon';
import Button from '../../../components/UI/Button/Button';
import Modal from '../../../components/UI/Modal/Modal';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import * as actions from '../../../store/actions/index';

import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Linkify from 'react-linkify';

class InterviewPreview extends Component {

    state = {
        showButton: true,
        isView: false,
        interviewDetails:{},
        activeCompany: '',
        pageTitle: 'CONFIRMATION PREVIEW',
        showDeleteModal:false
    }

    componentWillMount() { 
        if(this.props.location.state.isView){
            this.setState({isView: true});
            axios.get("/galaxy/interview-scheduler/interview?interviewId=" + this.props.location.state.interviewId)
            .then((response) => {ConsoleLog('checking api');ConsoleLog(response.data);
                if(response.data){
                    const intervieweeDetail  = response.data.intervieweeDetails.filter((interviewee) => 
                        interviewee.id == this.props.location.state.intervieweeId);
                        intervieweeDetail[0].slots.map( slot => {
                            slot.slot = slot.slot.substring(0, 19).replace("T", " ");
                        });
                    response.data.intervieweeDetails = intervieweeDetail;
                    this.setState({
                        interviewDetails: response.data,
                        pageTitle: response.data.interviewTitle,
                    });
                }
            });
        }else if(this.props.location.state.interviewDetails){
            this.setState({
                interviewDetails: this.props.location.state.interviewDetails,
                activeCompany: this.props.location.state.activeCompany
            });
        }
    }

    sendHandler = () => {
        ConsoleLog('send');
        this.setState({ showButton: false });
        axios.put('/galaxy/interview-scheduler/interview',{interviewId: this.props.location.state.interviewDetails.interviewId, interviewScheduleStatus: "Sent", userId: this.props.location.state.userId, userName: this.props.location.state.userName})
        .then((response) => {
            if(response.data.message === 'success'){
                this.props.history.push(
                    {
                      pathname: '/recruiter/interview-scheduler/',
                      state: {
                        message: 'Your invite has been sent'
                      }     
                }); 
            }
        })
        .catch((error) => {
            ConsoleLog(error);
        });
    }
    deleteHandlerModal = () => {
        this.setState({showDeleteModal:true})
    }
    handleCancelDeleteView = () => {
        this.setState({showDeleteModal:false})
    }
    handleDeleteView = () => {
        this.setState({showDeleteModal:false})
        if(this.props.location.state.interviewId!==0) {
        axios.put('/galaxy/interview-scheduler/interview',{interviewId:this.props.location.state.interviewId,
            intervieweeId:this.props.location.state.intervieweeId,
            interviewStatus: "Deleted", 
            userId: this.props.location.state.userId, 
            userName: this.props.location.state.userName})
          .then(response=> {
              this.props.onSetInterViewListCount({count:this.props.interviewListCount.count-1});  /*this should be properly handled once the proper save or draft option came*/
              
              this.props.history.push({
                pathname:'/recruiter/interview-scheduler',
                state:{
                  message:"Interview has been deleted"
                  }
              });
            
          })
          .catch((error) => {
            ConsoleLog(error);
          throw error;
          });
        }
        else {
          this.props.history.push({
            pathname:'/recruiter/interview-scheduler',
            state:{
              message:"Interview has been deleted"
              }
          });
        }
    }
    render() { 
        const header = (
            <div className="interview-preview-header">
                {/* Desktop View Section starts */}	
                <MediaQuery query="(min-device-width: 769px)">
                <div className="interview-preview-back" onClick={()=>{window.history.back()}}>
                    <Icon icon="left-arrow" className ="interview-preview-back-icon "/>
                    <span className="create-interview-preview-back">Back</span>
                </div>
                </MediaQuery>
                <MediaQuery query="(max-device-width: 768px)">
                <div className="interview-preview-back" onClick={()=>{window.history.back()}}>
                    <Icon icon="left-arrow" className ="interview-preview-back-icon "/>
                </div>
                </MediaQuery>

                {/* Desktop View Section Ends */}
                <h1>{this.state.pageTitle}</h1>
            </div>
        );

        const firstSection = (
            <div className="interview-preview-card-item-primary">
                <div className="first-item">
                    <label>Event Title</label>
                    <p>{this.state.interviewDetails.interviewTitle}</p>
                </div>
                <div className="first-item">
                    <label>Type of Interview</label>
                    <p>{this.state.interviewDetails.interviewType}</p>
                </div>
                <div className="first-item">
                    <label>Location of Interview</label>
                    <p>{this.state.interviewDetails.interviewLocation}</p>
                </div>
                <div className="first-item">
                    <label>Client Company</label>
                    <p>{this.state.isView?this.props.location.state.companyName:this.state.activeCompany.companyName}</p>
                </div>
            </div>
        );

        const candidateHeader = (
            <div className="preview-candidate-header">
                <table>
                    <th className="candidate-name">Candidate Name</th>
                    <th className="candidate-email">Candidate Email</th>
                    <th className="candidate-bullhornId">Bullhorn ID</th>
                    <th className="candidate-duration">Duration</th>
                    <th className="candidate-date">Date</th>
                    <th className="candidate-time">Time</th>
                </table>
            </div>
        );

        const candidateBody = this.state.interviewDetails.intervieweeDetails?this.state.interviewDetails.intervieweeDetails.map((candidate) => { 

            let statusAccepted = false;
            candidate.slots.map((slot) => {
                if(slot.status == 'ACCEPTED'){
                    statusAccepted = true;
                }
            });

            return(
                <div className="interview-preview-card-item-first">
                    <table className="tbl-interview-candidate-cards">
                                {candidate.slots.map((slot, index) => {
                                    const durationArray = candidate.duration.split(" ");
                                    let fullName = '';
                                    let email = '';
                                    let bullhornId = '';
                                    let statusClass = null;
                                    let icon = null;

                                    if(index == 0){
                                        fullName = candidate.fullName;
                                        email = candidate.email;
                                        bullhornId = candidate.bullhornId;
                                    }

                                    if(this.state.isView){
                                        if(slot.status){
                                            if(statusAccepted === false){
                                                switch(slot.status) {
                                                    case 'ACCEPTED':
                                                        statusClass = 'slotactive';
                                                        icon = "accepted";
                                                        break;
                                                    
                                                    case 'PENDING':
                                                        statusClass = 'slotpending';
                                                        icon = "pending";
                                                        break;
    
                                                    case 'REJECTED':
                                                        statusClass = 'slotrejected';
                                                        icon = "rejected";
                                                        break;
                                                }
                                            }else{
                                                switch(slot.status) {
                                                    case 'ACCEPTED':
                                                        statusClass = 'slotactive';
                                                        icon = "accepted";
                                                        break;
                                                }
                                            }
                                        }
                                    }

                                    return(
                                        <tr className={statusClass}>
                                            <td className="candidate-name">{fullName}</td>
                                            <td className="candidate-email">{email}</td>
                                            <td className="candidate-bullhornId">{bullhornId}</td>
                                            <td className="candidate-duration">{candidate.duration}</td>
                                            <td className="candidate-date">{moment(slot.slot).format('DD MMM YYYY')}</td>
                                            {candidate.duration==='30 mins'?
                                            <td className="candidate-time">{moment(slot.slot).format('hh:mma')} To {moment(slot.slot).add(30,'minutes').format('hh:mma')} {statusClass?<Icon icon={icon}></Icon>: null}
                                            </td>: 
                                            <td className="candidate-time">{moment(slot.slot).format('hh:mma')} To {moment(slot.slot).add(durationArray[0],'hours').format('hh:mma')} {statusClass?<Icon icon={icon}></Icon>: null}
                                            </td>}
                                        </tr>
                                        );
                                    })}
                    </table>
                </div>
            );
        }):null;
    
        const candidatesMobileView =  this.state.interviewDetails.intervieweeDetails?this.state.interviewDetails.intervieweeDetails.map((candidate) => {
            
            let statusAccepted = false;
            candidate.slots.map((slot) => {
                if(slot.status == 'ACCEPTED'){
                    statusAccepted = true;
                }
            });

            return (
                <div className="interview-preview-card-item-first">
                    <div className="candidate-details">
                        <label>Candidate Name</label>
                        <p>{candidate.fullName}</p>
                    </div>
                    <div className="candidate-details">
                        <label>Candidate Email</label>
                        <p>{candidate.email}</p>
                    </div>
                    <div className="candidate-details">
                        <label>Bullhorn ID</label>
                        <p>{candidate.bullhornId}</p>
                    </div>
                    <div >
                        <table className="interview-preview-candidate-card-table">
                            <tr>
                                <th>Duration</th>
                                <th>Date</th>
                                <th>Time</th>
                            </tr>
                            {candidate.slots.map((slot) => {
                                    let statusClass = null;
                                    let icon = null;

                                    if(this.state.isView){
                                        if(slot.status){
                                            if(statusAccepted === false){
                                                switch(slot.status) {
                                                    case 'ACCEPTED':
                                                        statusClass = 'slotactive';
                                                        icon= "accepted";
                                                        break;
                                                    
                                                    case 'PENDING':
                                                        statusClass = 'slotpending';
                                                        icon= "pending";
                                                        break;
    
                                                    case 'REJECTED':
                                                        statusClass = 'slotrejected';
                                                        icon= "rejected";
                                                        break;
                                                }
                                            }else{
                                                switch(slot.status) {
                                                    case 'ACCEPTED':
                                                        statusClass = 'slotactive';
                                                        icon= "accepted";
                                                        break;
                                                }
                                            }
                                        }
                                    }

                                    if(candidate.duration === "30 mins") {
                                        return (
                                            <tr  className={statusClass}>
                                                <td>{candidate.duration}</td>
                                                <td>{moment(slot.slot).format('DD MMM YYYY')}</td>
                                                <td>{moment(slot.slot).format('hh:mma')} To {moment(slot.slot).add(30,'minutes').format('hh:mma')}
                                                {statusClass?<Icon icon={icon}></Icon>: null}
                                                </td>
                                            </tr>
                                        );
                                    } else {
                                        const durationArray = candidate.duration.split(" ");
                                        return (
                                            <tr className={statusClass}>
                                                <td>{candidate.duration}</td>
                                                <td>{moment(slot.slot).format('DD MMM YYYY')}</td>
                                               <td>{moment(slot.slot).format('hh:mma')} To {moment(slot.slot).add(durationArray[0],'hours').format('hh:mma')}
                                               {statusClass?<Icon icon={icon}></Icon>: null}
                                               </td>
                                            </tr>
                                        );
                                    }
                            })}
                        </table>
                    </div>
                </div>
            );
        }): null;
               
    
        const secondSection = (
            <div>
                {/* Desktop View Section starts */}	
                <MediaQuery query="(min-device-width: 769px)">
                    {candidateHeader}
                    {candidateBody}
                </MediaQuery>
                {/* Desktop View Section Ends */}
    
                {/* Mobile View Section starts */}	
                <MediaQuery query="(max-device-width: 768px)">
                    {candidatesMobileView}
                </MediaQuery>
                {/* Mobile View Section Ends */}
            </div>
        );
    
        let preview = <Icon icon="Attached-doc" className="file-preview-icon"/>;
        let files = null;
        if(this.state.interviewDetails.interviewAttachments && this.state.interviewDetails.interviewAttachments !== ''){
            files = this.state.interviewDetails.interviewAttachments.split(";");
        }
        let thirdSectionDesktop = null;
        let thirdSectionMobile = null;
        
        if(this.state.interviewDetails.interviewMessage || files){
    
            thirdSectionMobile = (
                <div>
                    <div className="interview-preview-card-item-third">
                        <div className="interview-details-header-message">
                            <h1>Messages & Documents</h1>
                        </div>
                        <Linkify properties={{target: '_blank', style: {color: '#28b899', fontWeight: '400'}}}>
                            <div className="interview-preview-details-message">
                                <p>{this.state.interviewDetails.interviewMessage}</p>
                            </div>
                        </Linkify>
        
                        {files ? <div className="interview-preview-dropzone-files">
                            {files.map((file) => {
                                let fileName = file.split('/');
                                return (
                                    <div className="interview-preview-dropzone-file" >
                                        {preview}
                                        <span className="attach-file-name-ellipsis" title={file}>{fileName[1]}</span>
                                    </div>
                                );
                            })}
                        </div>: null}
                    
                    </div>
                    {/* {this.state.isView?
                    <div className="interview-preview-last-buttons">
                        <Button
                        buttonicon="archive-white"
                        > 
                        ARCHIVE
                        </Button>

                        <Button buttonicon="delete-white" onClick={this.deleteHandlerModal}>
                            DELETE
                        </Button> 
                    </div>
                    : 
                    <div className="interview-preview-last-buttons">
                        <Link to={{
                            pathname: '/recruiter/interview-scheduler/create-event',
                            state: {
                            interviewDetails: this.state.interviewDetails,
                            activeCompany:this.state.activeCompany
                            }
                            }}
                        >
                        <Button
                        buttonicon="edit-icon"
                        > 
                        EDIT
                        </Button>
                        </Link>
                        <Button buttonicon="send-icon">
                            SEND
                        </Button> 
                    </div>} */}
                                        
                </div>
            );
    
            thirdSectionDesktop = (
                <div>
                <div className="interview-preview-card-item-third">
                    <div className="interview-details-header-message">
                        <h1>Message & Documents</h1>
                    </div>
                    <Linkify properties={{target: '_blank', style: {color: '#28b899', fontWeight: '400'}}}>
                        <div className="interview-preview-details-message">
                            <p>{this.state.interviewDetails.interviewMessage}</p>
                        </div>
                    </Linkify>
    
                    {files ? <div className="interview-preview-dropzone-files">
                        {files.map((file) => {
                            let fileName = file.split('/');
                            return (
                                <div className="interview-preview-dropzone-file" >
                                    {preview}
                                    <span className="attach-file-name-ellipsis" title={file}>{fileName[1]}</span>
                                </div>
                            );
                        })}
                    </div>: null}
                </div> 
                {/* {this.state.isView? <div className="interview-preview-last-buttons">
                    { <Button
                        buttonicon="archive-white"
                        > 
                        ARCHIVE
                        </Button> }
                        {<Button buttonicon="delete-white" onClick={this.deleteHandlerModal} >
                            DELETE
                        </Button>  }
                    </div>: <div className="interview-preview-last-buttons">
                        <Link to={{
                            pathname: '/recruiter/interview-scheduler/create-event',
                            state: {
                            interviewDetails: this.state.interviewDetails,
                            activeCompany: this.state.activeCompany
                            }
                            }}
                        >
                            <Button
                            buttonicon="edit-icon"
                            > 
                            EDIT
                            </Button>
                        </Link>
                        <Button buttonicon="send-icon-line" onClick={this.sendHandler} disabled={!this.state.showButton}>
                            SEND
                        </Button> 
                    </div>} */}
                                        
                </div>
            );
        }else{
            thirdSectionDesktop = (
                <div>
                    {/* {this.state.isView? <div className="interview-preview-last-buttons">
                        { <Button
                        buttonicon="archive-white"
                        > 
                        ARCHIVE
                        </Button> }
                        { <Button buttonicon="delete-white" onClick={this.deleteHandlerModal}>
                            DELETE
                        </Button>  }
                    </div> : <div className="interview-preview-last-buttons">
                        <Link to={{
                            pathname: '/recruiter/interview-scheduler/create-event',
                            state: {
                            interviewDetails: this.state.interviewDetails,
                            activeCompany: this.state.activeCompany
                            }
                            }}
                        >
                            <Button
                            buttonicon="edit-icon"
                            > 
                            EDIT
                            </Button>
                        </Link>
                        <Button buttonicon="send-icon-line" onClick={this.sendHandler} disabled={!this.state.showButton}>
                            SEND
                        </Button> 
                    </div>} */}
                    
                </div>
            );
    
            thirdSectionMobile = (
                <div>
                    {/* {this.state.isView?  <div className="interview-preview-last-buttons">
                        {<Button
                        buttonicon="archive-white"
                        > 
                        ARCHIVE
                        </Button> }
                        { <Button buttonicon="delete-white" onClick={this.deleteHandlerModal}>
                            DELETE
                        </Button>  }
                    </div>:  <div className="interview-preview-last-buttons">
                        <Link to={{
                            pathname: '/recruiter/interview-scheduler/create-event',
                            state: {
                            interviewDetails: this.state.interviewDetails,
                            activeCompany: this.state.activeCompany
                            }
                            }}
                        >
                        <Button
                        buttonicon="edit-icon"
                        > 
                        EDIT
                        </Button>
                        </Link>
                        <Button buttonicon="send-icon" onClick={this.sendHandler} disabled={!this.state.showButton}>
                            SEND
                        </Button> 
                    </div>}   */}
                </div>
            );
        }
    
        const thirdSection = (
            <div>
                {/* Desktop View Section starts */}	
                <MediaQuery query="(min-device-width: 769px)">
                    {thirdSectionDesktop}
                </MediaQuery>
                {/* Desktop View Section Ends */}
    
                {/* Mobile View Section starts */}	
                <MediaQuery query="(max-device-width: 768px)">
                    {thirdSectionMobile}
                </MediaQuery>
                {/* Mobile View Section Ends */}
            </div>
        );

        /*fourth section*/
        const fourthSectionDesktop = this.state.interviewDetails.intervieweeDetails?
        this.state.interviewDetails.intervieweeDetails.map((candidate) => { 
        return(
        this.state.isView && candidate.message ?
        <div>
            <div className="interview-preview-card-item-fourth">
                <div className="interview-details-header-message">
                    <h1>Candidate Message</h1>
                    <Linkify properties={{target: '_blank', style: {color: '#28b899', fontWeight: '400'}}}>
                        <div className="interview-details-candidate-message">
                            <p>{candidate.message}</p>
                        </div>
                    </Linkify>
                </div>
            </div>
        </div>:""
        )}):"";
                        
        const fourthSectionMobile =  this.state.interviewDetails.intervieweeDetails?this.state.interviewDetails.intervieweeDetails.map((candidate) => {
            return (
                this.state.isView && candidate.message ?
                <div>
                    <div className="interview-preview-card-item-fourth">
                        <div className="interview-details-header-message">
                            <h1>Candidate Message</h1>
                            <Linkify properties={{target: '_blank', style: {color: '#28b899', fontWeight: '400'}}}>
                                <div className="interview-details-candidate-message">
                                    <p>{candidate.message}</p>
                                </div>
                            </Linkify>
                        </div>
                    </div>
            
        </div>:""
        )}):"";
 
        const fourthSection = (
            <div>
                {/* Desktop View Section starts */}	
                <MediaQuery query="(min-device-width: 769px)">
                    {fourthSectionDesktop}
                </MediaQuery>
                {/* Desktop View Section Ends */}
    
                {/* Mobile View Section starts */}	
                <MediaQuery query="(max-device-width: 768px)">
                    {fourthSectionMobile}
                </MediaQuery>
                {/* Mobile View Section Ends */}
            </div>
        );


    /*common delete,edit and send buttons */

      const button = this.state.isView?<div className="interview-preview-last-buttons">
        {/* <Button
        buttonicon="archive-white"
        > 
        ARCHIVE
        </Button> */}

        <Button buttonicon="delete-white" onClick={this.deleteHandlerModal}>
            DELETE
        </Button> 
     </div>
     : <div className="interview-preview-last-buttons">
        <Link to={{
            pathname: '/recruiter/interview-scheduler/create-event',
            state: {
            interviewDetails: this.state.interviewDetails,
            activeCompany:this.state.activeCompany
            }
        }}
        >
        <Button
            buttonicon="edit-icon"
        > 
        EDIT
        </Button>
        </Link>
        <Button buttonicon="send-icon" onClick={this.sendHandler} disabled={!this.state.showButton}>
            SEND
        </Button> 
    </div>

        return(            
            <div className="interview-preview-container">
                {header}
                {firstSection}
                {secondSection}
                {thirdSection}
                {fourthSection}
                {button}
                <Modal className="interview-view-delete-modal" show={this.state.showDeleteModal===true}>
                    <p>Are you sure you want to delete ?</p>
                    <div className="delete-interview-view-buttons">
                        <Button className="interview-view-delete-cancel" onClick={this.handleCancelDeleteView}>Cancel</Button>
                        <Button className="interview-view-delete-confirm"  onClick={()=>this.handleDeleteView()}>Yes, Delete</Button>
                    </div>
                </Modal>  
            </div>                  
        );
    }
}
/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => ({
    interviewListCount: state.clientProfile.interviewListCount  
  }); 
  
  /**
  * @desc connecting to redux actions
  * @param dispatch
  * @return redux actions
  */
  const mapDispatchToProps = dispatch => {
    return {
      onSetInterViewListCount:(count) => dispatch(actions.setInterViewListCount(count)),
    }
  }

export default connect(mapStateToProps,mapDispatchToProps)(InterviewPreview);


// WEBPACK FOOTER //
// ./src/components/Recruiter/InterviewPreview/InterviewPreview.js